import React from 'react';
import filterConnect from '../../../../../common/hoc/filterConnect';
import moment from 'moment';

const OrderStatus = ({ order, orderStatuses, ...rest }) => {
  console.log(order);
  return (
    <React.Fragment>
      {order && (
        <React.Fragment>
          <div
            className="sidebar-info__item"
            style={{ justifyContent: 'center' }}
          >
            <span>Статус заказа</span>
          </div>
          <div className="sidebar-info__item">
            {orderStatuses &&
              orderStatuses.map(
                item =>
                  item.orderStatusKey === order.orderState.statusKey && (
                    <span key={item.orderStatusKey}>{item.orderStatus}</span>
                  )
              )}
            <span>{moment(order.info.create).format('DD.MM.YYYY')}</span>
          </div>
          <div className="sidebar-info__item">
            <span>Принят</span>
            <span>{moment(order.info.create).format('DD.MM.YYYY')}</span>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default filterConnect(OrderStatus, ['orderStatuses']);
